import { SetOwner } from '@adaptiva/core/common';
import { provideBaseWidget } from '@adaptiva/core/widgets';
import { BaseEditorError, EEditorErrorType, IBaseEditorError } from '@adaptiva/data-service';
import { InputComponent } from '@adaptiva/widgets/input';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { BaseScheduleTypeComponent } from '../base-schedule-type.component';

@Component({
	standalone: false,
	selector: 'app-recurring-by-date',
	templateUrl: './recurring-by-date.component.html',
	providers: [provideBaseWidget(() => RecurringByDateComponent)],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecurringByDateComponent extends BaseScheduleTypeComponent {

	@ViewChild('RecurringIntervalInMonthsInput')
	@SetOwner recurringIntervalInMonthsInput: InputComponent;

	@ViewChild('DayOfMonthInput')
	@SetOwner dayOfMonthInput: InputComponent;

	public numberOfMonths = 1;

	public dayOfMonth = 1;

	public validate(): IBaseEditorError[] {
		const _errors: IBaseEditorError[] = [];

		if (this.numberOfMonths < 1) {
			_errors.push(
				new BaseEditorError(
					EEditorErrorType.Error,
					this.guid,
					['RecurringIntervalInMonthsInput', 'Number of months must be greater than 0']
				)
			);
		}

		if (this.dayOfMonth < 1 || this.dayOfMonth > 31) {
			_errors.push(
				new BaseEditorError(
					EEditorErrorType.Error,
					this.guid,
					['DayOfMonthInput', 'Must provide a valid day of the month']
				)
			);
		}

		return _errors;
	}

	public commitModelToView(): void {
		if (this.schedule) {
			this.numberOfMonths = this.schedule.numberOfMonths;
			this.dayOfMonth = this.schedule.dayOfMonth;
		}
	}

	// event listeners start
	setNumberOfMonths(event: string) {
		const months = +event;

		if (months !== this.numberOfMonths) {
			this.numberOfMonths = +event;
			this.outputChanges([
				{ propertyName: 'numberOfMonths', value: this.numberOfMonths }
			]);
		}
	}

	setDayOfMonth(event: string) {
		const day = +event;

		if (day !== this.dayOfMonth) {
			this.dayOfMonth = +event;
			this.outputChanges([
				{ propertyName: 'dayOfMonth', value: this.dayOfMonth }
			]);
		}
	}
	// event listeners end

}
